import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_TIMESHEET_PROGRESS_DETAILS } from "src/api-setup/api-endpoints";

export const getTimesheetProgressDetails = async (cookiesData, dispatch, timesheetMstrKey) => {
  if (!cookiesData || !timesheetMstrKey) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_timesheet_mstr_key: timesheetMstrKey,
      in_filter: null,
      in_sort_number: 1,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, GET_TIMESHEET_PROGRESS_DETAILS, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.row_result) {
      const rowResult = response.data.row_result;
      // Ensure we always return an array
      return Array.isArray(rowResult) ? rowResult : [];
    }

    return [];
  } catch (error) {
    console.error("Error fetching timesheet progress details:", error);
    return [];
  }
};
